import React, {Component} from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';

import Homepage from './homepage/homepage';
import Catagory from './catagory/catagory';
import SingleCategory from './singleCategory/singleCategory';
import SingleItem from './singleItem/singleItem';

import OrderPage1 from './orderPage1/orderPage1';
import OrderPage2 from './orderPage2/orderPage2';
import OrderPage3 from './orderPage3/orderPage3';
import OrderPage4 from './orderPage4/orderPage4';

import AboutBorisAndMatthew from './aboutBorisAndMatthew/aboutBorisAndMatthew';
import OurClient from './ourClient/ourClient';
import OurPartners from './ourPartners/ourPartners';
import ContactUs from './contactUs/contactUs';
import Faqs from './Faqs/Faqs'
import Privacy  from './privacy/Privacy'
import SingleItemWithSubCategory from './singleItem/singleItemWithSubCat'

class App extends Component {
  render() {
    return (
      <BrowserRouter>
        <div className='switch'>
          <Switch>
            <Route path="/category/all" component={Catagory} />
            <Route path="/category/:catename/:id" component={SingleItem} />
            <Route path="/category/:catename" component={SingleCategory} />
            <Route path="/subcategory/category/:subcategory/:category" component={SingleItemWithSubCategory} />
            <Route path="/order/cartlist" component={OrderPage1} />
            <Route path="/order/info" component={OrderPage2} />
            <Route path="/order/submit" component={OrderPage3} />
            <Route path="/order/complete" component={OrderPage4} />
            <Route path="/about-boris-and-matthew" component={AboutBorisAndMatthew} />
            <Route path="/our-partners" component={OurPartners} />
            <Route path="/our-client" component={OurClient} />
            <Route path="/contact-us" component={ContactUs} />
            <Route path="/conditions" component={Faqs} />
            <Route path="/privacy" component={Privacy} />
            <Route path="/" component={Homepage} />
          </Switch>
        </div>
      </BrowserRouter>
    );
  }
}
export default App;



// WEBPACK FOOTER //
// ./src/components/App.js